import { Action } from '@ngrx/store';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { JobStatusResponse, LoadJobStatusListRequest, LoadJobStatusListResponse, PagingSorting } from '../../models';

export enum JobStatusActionTypes {
  ExecuteSearch = '[JobStatus] Execute Search',

  ProcessQueryString = '[JobStatus] Process Query String',

  NextPage = '[JobStatus] Next Page',
  PrevPage = '[JobStatus] Previous Page',
  SetPageSize = '[JobStatus] Set Page Size',
  LastPage = '[JobStatus] Last Page',
  FirstPage = '[JobStatus] First Page',
  SortBy = '[JobStatus] Sort By',

  LoadJobStatusList = '[JobStatus] Summary',
  LoadJobStatusListSuccess = '[JobStatus] Summary Success',
  LoadJobStatusListFailure = '[JobStatus] Summary Failure',

  LoadJobStatusDetails = '[JobStatus] Details',
  LoadJobStatusDetailsSuccess = '[JobStatus] Details Success',
  LoadJobStatusDetailsFailure = '[JobStatus] Details Failure'
}

export class ProcessQueryString implements Action {
  readonly type = JobStatusActionTypes.ProcessQueryString;
  constructor(public payload: string) {}
}

export class NextPage implements Action {
  readonly type = JobStatusActionTypes.NextPage;
  constructor(public payload: LoadJobStatusListRequest, public pagingSorting: PagingSorting) {}
}

export class PrevPage implements Action {
  readonly type = JobStatusActionTypes.PrevPage;
  constructor(public payload: LoadJobStatusListRequest, public pagingSorting: PagingSorting) {}
}

export class SetPageSize implements Action {
  readonly type = JobStatusActionTypes.SetPageSize;
  constructor(public payload: number, public searchCriteria: LoadJobStatusListRequest) {}
}

export class LastPage implements Action {
  readonly type = JobStatusActionTypes.LastPage;
  constructor(public payload: LoadJobStatusListRequest, public pagingSorting: PagingSorting) {}
}

export class FirstPage implements Action {
  readonly type = JobStatusActionTypes.FirstPage;
  constructor(public payload: LoadJobStatusListRequest, public pagingSorting: PagingSorting) {}
}

export class SortBy implements Action {
  readonly type = JobStatusActionTypes.SortBy;
  constructor(public payload: string, public searchCriteria: LoadJobStatusListRequest, public pagingSorting: PagingSorting) {}
}

export class ExecuteJobStatusSearch implements Action {
  readonly type = JobStatusActionTypes.ExecuteSearch;
  constructor(public payload: LoadJobStatusListRequest) {}
}

export class LoadJobStatusList implements Action {
  readonly type = JobStatusActionTypes.LoadJobStatusList;
  constructor(public payload: LoadJobStatusListRequest) {}
}

export class LoadJobStatusListSuccess implements Action {
  readonly type = JobStatusActionTypes.LoadJobStatusListSuccess;
  constructor(public payload: LoadJobStatusListResponse, public httpHeaders: HttpHeaders) {}
}

export class LoadJobStatusListFailure implements Action {
  readonly type = JobStatusActionTypes.LoadJobStatusListFailure;
  constructor(public payload: HttpErrorResponse | string) {}
}

export class LoadJobStatusDetails implements Action {
  readonly type = JobStatusActionTypes.LoadJobStatusDetails;
  constructor(public payload: number) {}
}

export class LoadJobStatusDetailsSuccess implements Action {
  readonly type = JobStatusActionTypes.LoadJobStatusDetailsSuccess;
  constructor(public payload: JobStatusResponse) {}
}

export class LoadJobStatusDetailsFailure implements Action {
  readonly type = JobStatusActionTypes.LoadJobStatusDetailsFailure;
  constructor(public payload: HttpErrorResponse | string) {}
}

export type JobStatusActions =
  | LoadJobStatusList
  | LoadJobStatusListSuccess
  | LoadJobStatusListFailure
  | LoadJobStatusDetails
  | LoadJobStatusDetailsSuccess
  | LoadJobStatusDetailsFailure
  | ExecuteJobStatusSearch
  | ProcessQueryString
  | NextPage
  | PrevPage
  | SetPageSize
  | LastPage
  | FirstPage
  | SortBy;
